export const invoicesTableTitle = 'Invoices for clients'